import { EditOtherContentApiRequest } from '@/data/payload/api/OtherContentRequest'
import { EditOtherContentInterface } from '@/data/payload/contracts/OtherContentRequest'
import ApiService from '@/app/framework/services/ApiServices'
import { OtherContentDataMapper } from '@/data/persistences/mappers/OtherContentDataMapper'
import { OtherContentRepositoryInterface } from '@/data/persistences/repositories/contracts/OtherContentRepositoryInterface'
import { OtherContent } from '@/domain/entities/OtherContent'
import { Endpoints } from '@/app/framework/misc/Endpoints'

export class OtherContentApiRepository
  implements OtherContentRepositoryInterface {
  private service: ApiService
  private mapper: OtherContentDataMapper

  constructor(service: ApiService, mapper: OtherContentDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async getAll(params: Object, name: string): Promise<OtherContent> {
    const resp = await this.service.invoke(
      'get',
      `${Endpoints.Route.OTHER_CONTENT}/${name}`,
      params
    )
    return this.mapper.convertOtherContentFromApi(resp)
  }

  public async update(
    payload: EditOtherContentInterface
  ): Promise<OtherContent> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.OTHER_CONTENT,
      undefined,
      payload as EditOtherContentApiRequest,
      undefined,
      'form-data'
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }
}
